<template>
  <div :class="b()">
    <div class="avue-notice__item "
         :key="index"
         @click="click(item)"
         v-for="(item,index) in data">
      <div class="avue-notice__img"
           v-if="item[imgKey]">
        <img :src="item[imgKey]"
             alt="">
      </div>
      <div class="avue-notice__content">
        <div class="avue-notice__title">
          <span class="avue-notice__tag"
                v-if="item[tagKey]">
            <el-tag size="small"
                    :type="getType(item[statusKey])">{{item[tagKey]}}</el-tag>
          </span>
          <span class="avue-notice__name"
                @click="$emit('theClick',item)"
                :title="item[titleKey]"
                v-ellipsis="2"> {{item[titleKey]}} </span>
        </div>
        <div class="avue-notice__subtitle">{{item[subtitleKey]}}</div>
      </div>
    </div>
    <div class="avue-notice__more"
         v-if="!finish"
         v-loading="loading"
         @click="handleClick(false)">
      加载更多
    </div>
    <div class="avue-notice__more"
         v-if="finish"
         v-loading="loading"
         @click="handleClick(true)">
      没有更多啦! 点击刷新
    </div>
  </div>
</template>

<script>
const propsDefault = {
  img: 'img',
  title: 'title',
  subtile: 'title',
  tag: 'tag',
  status: 'status',
}
const ELEMENT = '__'
const MODS = '--'

const join = (name, el, symbol) => (el ? name + symbol + el : name)

const prefix = (name, mods) => {
  if (typeof mods === 'string') {
    return join(name, mods, MODS)
  }

  if (Array.isArray(mods)) {
    return mods.map((item) => prefix(name, item))
  }

  const ret = {}
  Object.keys(mods || {}).forEach((key) => {
    ret[name + MODS + key] = mods[key]
  })
  return ret
}

// import create from 'core/create'
export default {
  name: 'NoticeView',
  props: {
    finish: {
      type: Boolean,
      default: false,
    },

    isMre: {
      type: Boolean,
      default: true,
    },
    option: {
      type: Object,
      default: () => {
        return {}
      },
    },
    data: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      page: 1,
      loading: false,
    }
  },
  computed: {
    props() {
      return this.option.props || propsDefault
    },
    imgKey() {
      return this.props.img || propsDefault.img
    },
    titleKey() {
      return this.props.title || propsDefault.title
    },
    subtitleKey() {
      return this.props.subtitle || propsDefault.subtitle
    },
    tagKey() {
      return this.props.tag || propsDefault.tag
    },
    statusKey() {
      return this.props.status || propsDefault.status
    },
  },
  methods: {
    b(el, mods) {
      const { name } = this.$options

      if (el && typeof el !== 'string') {
        mods = el
        el = ''
      }
      el = join(name, el, ELEMENT)

      return mods ? [el, prefix(el, mods)] : el
    },

    click(item) {
      this.$emit('click', item)
    },
    handleClick(type) {
      this.loading = true
      const done = () => {
        this.loading = false
      }
      if (!type) this.page++
      this.$emit('page-change', this.page, done, type)
    },
    getType(status = 0) {
      if (status == 0) {
        return 'info'
      } else if (status == 1) {
        return ''
      } else if (status == 2) {
        return 'warning'
      } else if (status == 3) {
        return 'danger'
      } else if (status == 4) {
        return 'success'
      }
    },
  },
}
</script>

<style scoped>
/* ::v-deep .avue-notice__name {
  height: 52px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */

/* ::v-deep .avue-notice__title {
  width: calc(100% - 48px);
} */
</style>
